<template>
	<div class="event-participant">
		<h6 class="font-sans bold">
			{{ $t('common.personal_details') }}

			<a v-if="!isFirst" href="#" class="pull-right" v-on:click.prevent="removeParticipant">
				<i class="fa fa-times" aria-hidden="true"></i>
			</a>
		</h6>

		<validation-observer :ref="'participantObserver' + suffix" :vid="'participantObserver' + suffix">
			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<validation-provider rules="required" v-slot="{ failedRules }" name="salutation">
							<multiselect v-model="selectedSalutation" :showLabels="false" @select="selectSalutation" :options="salutations" track-by="id" label="name" :placeholder="$t('common.salutation')"></multiselect>
							<input-errors :errors="failedRules" />
						</validation-provider>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<div class="form-group text required float-label-control">
						<validation-provider rules="required" v-slot="{ failedRules }" name="first_name">
							<input v-model="participant.first_name" type="text" :name="prefix + 'first_name'" required="required" maxlength="64" :id="prefix + 'first-name'" class="form-control empty">
							<label class="control-label" :for="prefix + 'first_name'">
								{{ $t('common.first_name') }}
							</label>
							<input-errors :errors="failedRules" />
						</validation-provider>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group text required float-label-control">
						<validation-provider rules="required" v-slot="{ failedRules }" name="last_name">
							<input v-model="participant.last_name" type="text" :name="prefix + 'last_name'" required="required" maxlength="64" :id="prefix + 'last-name'" class="form-control empty">
							<label class="control-label" :for="prefix + 'last_name'">
								{{ $t('common.last_name') }}
							</label>
							<input-errors :errors="failedRules" />
						</validation-provider>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-7">
					<div class="form-group email required float-label-control">
						<validation-provider rules="required|email" v-slot="{ failedRules }" name="email">
							<input v-model="participant.email" type="email" :name="prefix + 'email'" required="required" maxlength="255" :id="prefix + 'email'" class="form-control empty">
							<label class="control-label" :for="prefix + 'email'">
								{{ $t('common.email') }}
							</label>
							<input-errors :errors="failedRules" />
						</validation-provider>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-5">
					<div class="form-group">
						<validation-provider rules="required" v-slot="{ failedRules }" name="country">
							<multiselect v-model="selectedCountry" @select="selectCountry" :showLabels="false" :options="countries" :placeholder="$t('common.country')" track-by="id" label="country"></multiselect>
							<input-errors :errors="failedRules" />
						</validation-provider>
					</div>
				</div>
				<div class="col-md-7">
					<div class="form-group text required float-label-control">
						<validation-provider rules="required" v-slot="{ failedRules }" name="city">
							<input v-model="participant.city" type="text" required="required" maxlength="128" :id="prefix + 'city'" class="form-control empty">
							<label class="control-label" :for="prefix + 'city'">
								{{ $t('common.city') }}
							</label>
							<input-errors :errors="failedRules" />
						</validation-provider>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-5">
					<div class="form-group select">
						<div class="form-group">
							<multiselect v-model="selectedSector" @select="selectSector" :showLabels="false" :options="sectors" track-by="id" label="name" :placeholder="$t('common.sectors')"></multiselect>
						</div>
					</div>
				</div>
			</div>

			<h6 class="font-sans bold company-details">
				{{ $t('common.company_details') }}
			</h6>

			<div class="checkbox checkbox-default" v-if="!isFirst">
				<input v-model="participant.companyDiffersFromFirstAttendee" type="checkbox" id="company-differs">
				<label :for="prefix + 'company-differs'">
					{{ $t('event_registration.company_details_differ') }}
				</label>
			</div>

			<div v-if="isFirst || participant.companyDiffersFromFirstAttendee">
				<div class="row">
					<div class="col-md-7">
						<div class="form-group text float-label-control">
							<input v-model="participant.company_name" type="text" maxlength="255" :id="prefix + 'company-name'" class="form-control empty">
							<label class="control-label" :for="prefix + 'company-name'" v-t="'common.company_name'"></label>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-7">
						<div class="form-group text float-label-control">
							<input v-model="participant.company_website" type="text" maxlength="255" :id="prefix + 'company-website'" class="form-control empty">
							<label class="control-label" :for="prefix + 'company-website'" v-t="'common.company_website'"></label>
						</div>
					</div>
				</div>
			</div>

		</validation-observer>
	</div>
</template>

<script>
import CountriesApi from 'WaApi/Countries';
import ListsApi from 'WaApi/Lists';
import EventBus from 'WaApi/EventBus';

export default {
	name: 'EventAttendee',

	components: {
	},

	props: {
		participant: {
			required: true,
			type: Object
		},
		index: {
			required: false,
			default: function () {
				return null;
			},
			type: Number
		}
	},

	mounted() {
		ListsApi.getLists().then((result) => {
			this.salutations = result.data.lists.salutations;
			this.sectors = result.data.lists.sectors;
		});

		CountriesApi.getAll().then((result) => {
			for (const [key, value] of Object.entries(result.data.countries)) {
				this.countries.push({
					id: key,
					country: value
				});
			}
			this.countries.sort((first, second) => {
				return first.country > second.country ? 1 : -1
			});
		});
	},

	computed: {
		isFirst: function() {
			return this.index === null || this.index === 0;
		},
		prefix: function () {
			if (this.index === null) {
				return '';
			}

			return this.index + '-';
		},
		suffix: function () {
			if (this.index === null) {
				return '';
			}

			return this.index;
		},
	},

	methods: {
		removeParticipant: function() {
			EventBus.$emit(
				'EventRegistration.removeParticipant',
				this.participant
			);
		},

		selectSalutation(selectedOption) {
			this.participant.salutation_id = selectedOption.id;
		},

		selectCountry(selectedOption) {
			this.participant.country_id = selectedOption.id;
		},

		selectSector(selectedOption) {
			this.participant.company_type_id = selectedOption.id;
		},

		updateFloatLabels() {
			Vue.nextTick(function () {
				window.$('.float-label-control').floatLabels();
			});
		}
	},

	watch: {
		participant: {
			deep: true,
			handler: function() {
				this.updateFloatLabels();
			}
		}
	},

	data: function () {
		return {
			selectedSalutation: null,
			selectedCountry: null,
			selectedSector: null,
			countries: [],
			salutations: [],
			sectors: []
		};
	}
}
</script>

<style>
.multiselect__tags {
	border-radius: 0;
	border-color: #ccc;
}
.event-participant {
	margin-top: 50px;
}
.company-details {
	margin-top: 30px;
}
</style>
